'use strict';

// <a href="#" scroll-to="">Link</a>
function scrollTo($location, $anchorScroll) {
  return (scope, element, attrs) => {
    element.bind('click', (event) => {
      event.stopPropagation();

      let off = scope.$on('$locationChangeStart', (e) => {
        off();
        e.preventDefault();
      });

      $location.hash(attrs.scrollTo);
      $anchorScroll();
    });
  };
}

scrollTo.$inject = ['$location', '$anchorScroll'];

angular
  .module('SendRegning')
  .directive('scrollTo', scrollTo);
